import type { BlockTag } from "./groupFormat";

/** Strip HTML tags to test for real text content. */
export const stripHtml = (html: string): string =>
    (html ?? "").replace(/<[^>]*>/g, "").trim();

/** `inner` wrapped in a toolbar block tag (label/small are paragraph classes). */
export const wrapInTag = (tag: BlockTag, inner = "", style = ""): string => {
    if (tag.startsWith("h")) return `<${tag}${style}>${inner}</${tag}>`;
    const cls = tag === "paragraph" ? "" : ` class="lomda-v3-${tag}"`;
    return `<p${cls}${style}>${inner}</p>`;
};

/**
 * Default a title/question field to its `tag` (from the section registry's
 * `fieldTags`).
 * - Empty → an empty `tag` seed (placeholder shows at that tag's size).
 * - Legacy plain text (from the old `<input>`-based blocks) → wrapped in `tag`.
 * - Content that already carries a block tag is returned as-is, so a tag the
 *   author picked via the toolbar (e.g. paragraph, H4) is respected.
 *
 * `align` sets the default text alignment, applied only while seeding/wrapping
 * (never overriding an alignment the author already chose on tagged content).
 */
export const seedTitleHtml = (
    html: string,
    tag: BlockTag,
    align?: "left" | "center" | "right"
): string => {
    const trimmed = (html ?? "").trim();
    const style = align ? ` style="text-align: ${align}"` : "";
    if (!trimmed) return wrapInTag(tag, "", style);
    if (/^<(h[1-6]|p|ul|ol|blockquote|div|table)/i.test(trimmed)) return trimmed;
    return wrapInTag(tag, trimmed, style);
};
